export default __webpack_public_path__ + "static/media/illustration.b8ec7efe.png";